import { render } from "./MyinvDocs.vue?vue&type=template&id=a1a99002&scoped=true&ts=true"
import script from "./MyinvDocs.vue?vue&type=script&lang=ts"
export * from "./MyinvDocs.vue?vue&type=script&lang=ts"

import "./MyinvDocs.vue?vue&type=style&index=0&id=a1a99002&scoped=true&lang=scss"

import exportComponent from "/Users/pradipdobariya/Documents/projects/DMA Global/caprock-merchant-old/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a1a99002"]])

export default __exports__